import { AxiosError, AxiosResponse } from 'axios';
import { APIResponse } from '../Helper/type';
import ISwitchUser from './SwitchUser.interface';
import { handleApiResponse } from '../Helper/apiResponseHandler';
import apiCallWrapper from '../../apiwrapper/apiCallWrapper';

// Declaring the web server path
const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');
export default class SwitchUserToAdmin {
  public apiResponse: APIResponse = { statusCode: 500, body: 'Unexpected error occurred' };

  // Declaring the constructor to get the request body. This constructor is of type IOrgUser
  constructor(public userInfo: ISwitchUser) {}

  // Declaring the sub-path
  public subPath: string = '/switchuser';

  // POST request for creating Organization Users and storing it to db. This methods returns a response body along with a status code.
  public async switchUserToAdmin(): Promise<APIResponse> {
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(this.subPath, 'POST');
      const url: string = this.createUrl(this.subPath);
      const requestBody: ISwitchUser = this.userInfo;
      const response: AxiosResponse = await axiosWithRoles.post(url, requestBody);
      const errorMessage = 'Something went wrong while switching user to admin';
      const successMessage = 'User has been successfully switched to Organisation Admin';
      this.apiResponse = handleApiResponse(response.status, errorMessage, successMessage);
    } catch (error: unknown) {
      const axiosErr = error as AxiosError;
      switch (axiosErr?.response?.status) {
        case 406:
          this.apiResponse = {
            statusCode: 404,
            body: 'Requested OrganizationUser details is not found in the database'
          };
          break;
        case 400:
          this.apiResponse = {
            statusCode: 400,
            body: 'Not Authorised to perform this action'
          };
          break;
        default:
          this.apiResponse = { statusCode: 500, body: axiosErr?.message || String(error) };
      }
    }
    return this.apiResponse;
  }

  // Binding the Webserver path and sub-path

  private createUrl(params?: string): string {
    return backEndServerUrl + params;
  }
}
